import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import CommunityChannelActivityListForm from '@src/features/tenant/community/CommunityChannelActivityListForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function CommunityUserActivityList() {
  return (
    <TenantRoleGuard canRoles={[TENANT_ROLE.ADMIN]}>
      <TenantDefaultLayout>
        <CommonHelmet />
        <CommunityChannelActivityListForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default CommunityUserActivityList;
